import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import ButtonsSettingsContent from 'hb-builder/components/BuilderComponents/single/Buttons/ButtonsSettings/Content/ContentSettings';
import DisplayOption from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DisplayOption';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import { useBuilderConfigContext } from 'hb-builder/hooks';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { ButtonsItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/buttonsItemAttributes';
import type { HeroItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/heroItemAttributes';

import BackgroundImage from './BackgroundImage';
import Button from './Button';
import Headline from './Headline';
import Subline from './Subline';

const Content = ({
  item,
  onChange,
  permissions,
}: ComponentSettingsTab<HeroItemAttributes>) => {
  const {
    features: {
      hero: { hasDoubleButtons },
    },
  } = useBuilderConfigContext();

  const settingProps = { onChange, permissions };

  if (!item.children || !item.children[0].children) {
    return null;
  }

  const [headline, subline, button] = item.children[0].children;
  const {
    can: { imageBg: canSetImageBackground },
  } = permissions || { can: { imageBg: false } };

  return (
    <Wrapper>
      <AccordionTitle isInitiallyOpen title={__('Headline')}>
        <Headline {...settingProps} item={headline} />
      </AccordionTitle>
      <AccordionTitle title={__('Subline')}>
        <Subline {...settingProps} item={subline} />
      </AccordionTitle>
      <AccordionTitle title={hasDoubleButtons ? __('Button(s)') : __('Button')}>
        <DisplayOption
          title={__('Display button')}
          item={button}
          {...settingProps}
        />
        {hasDoubleButtons ? (
          <ButtonsSettingsContent
            onChange={onChange}
            item={button as DocumentItem<ButtonsItemAttributes>}
          />
        ) : (
          <Button {...settingProps} item={button} />
        )}
      </AccordionTitle>
      <AccordionTitle
        title={
          canSetImageBackground ? __('Background') : __('Background Image')
        }
      >
        <BackgroundImage {...settingProps} item={item} />
      </AccordionTitle>
    </Wrapper>
  );
};

export default Content;

const Wrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  width: '100%',
}))``;
